// extracted by mini-css-extract-plugin
export var closeButton = "_1h-3";
export var header = "_1h-0";
export var link = "_1h-1";
export var retryButton = "_1h-2";